export const MAX_ASSIGNMENT_TITLE_CHAR_LENGTH = 255;

export const MAX_GRADE_POINTS = 99999;

export const isShowTimeZone = true;

export enum AssignmentAttemptLimit {
  UNLIMITED = 'UNLIMITED',
  LIMITED = 'LIMITED',
}

export const MAX_ALLOWED_ATTEMPTS = 99;
export const ALLOWED_ATTEMPTS_ERROR_MESSAGE = `Please enter a number between 1 and ${MAX_ALLOWED_ATTEMPTS}.`;
